/*/////////////////////////////////////////////////*/
import React from "react";
import {isMobile} from 'react-device-detect';
import { vaultServices } from "../../libs/VaultServices";
import union from "lodash/union";
import uniqBy from "lodash/uniqBy";
import CountDown from '../../components/CountDown';

/* Design assets */
import './main.css';
import { withStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import BlockIcon from '@material-ui/icons/Block';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Brightness3Icon from '@material-ui/icons/Brightness3';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Fade from '@material-ui/core/Fade'; 

const styles = theme => ({

  root: theme.mixins.gutters({
    paddingTop: 1,
    paddingBottom: 1,
    marginTop: theme.spacing.unit * 3,
    opacity: 0.6,
    width: '80%',
    textAlign: 'center',
    fontWeight:'bold',
    backgroundColor: '#3ab9c5' ,      
  }),
  box: {
    backgroundColor: '#3ab9c5',
    border: '1px solid black',
    borderRadius: 16,
    width: 240,
    opacity: 0.6,
    marginTop: 1,
    marginBottom: 6
  },
  boxBLEWarn: {
    backgroundColor: '#fcffbd',
    border: '1px solid black',
    width: '80%',
    opacity: 0.6,
    marginTop: 1,
    marginBottom: 4,    
  },
  bleRefreshButton: {
    backgroundColor: '#f7f5e1',
    border: '1px solid black',
    fontSize: 10,
    fontWeight: "bold",
    marginTop: "1em",
    marginBottom: ".5em",
    width: 120
  },
  button: {
    backgroundColor: '#3ab9c5',
    border: '1px solid black',
    fontSize: 12,
    width: 200,    
  },
  placeholder: {
    height: 40
  },
  table: {
    width: 240
  },
  tableRow: {
    "&:last-child th, &:last-child td": {
      borderBottom: 0
    }
  },
  sleepProgress: {
    color: 'red',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  titleBLE: {
    color: 'white'
  },
  bleListing: {
    height: 380,
    overflowX: 'scroll',
    marginBottom: 0
  },
  stickyFooter:{
    paddingTop: "1vh",
    paddingBottom: "1vh",
    width: 150,
    marginLeft:40,
    marginRight: 80,
    marginBottom: 0,
    marginTop: 0,
    lineHeight: 3
  },
  buttonIcons: {
    width: 15,
    paddingRight: 12,
    textAlign: "left",
    display: "block",
    lineHeight: "unset !important"
  },
  buttonText: {
    margin: 0,
    padding: 0,
    width: 135,
    textAlign: "left"
  }
});
/* Design assets end */
/* neat way to console */
const ConsoleLog = ({ children }) => {
  console.log(children);
  return false;
};
/* see? */

class Main extends React.Component {
  constructor (props) {
    super(props)
    
    this.state = {
      orgId: "",
      orgIdError: "",
      username: "",
      usernameError: "",
      password: "",
      passwordError: "",
      authenticationError: "", 
      vaultIdError: "",   
      loading: false,
      error: null,
      errorInfo: null,
      vaultList: null,            
      itemDisabled: false, 
      isRunning: true,
      timerOn: false,
      timerStart: 0,
      timerTime: 150,
      count: 0,
      counter: {
        vaultId: "",
        counter: 0
      },
      hasRun: false
    }      
  }

  componentDidMount() {
    let user = sessionStorage.getItem("user");
      if (user) {
       // console.log(user);
        let x = JSON.parse(user);
        this.setState(() => ({
          userId: x.userId,
          token: x.token,
          orgId: x.orgId
        }));    
        this.startHunting();
        // console.log("in componentdidmount");
      } 
  }
  
  componentWillUnmount(){
    // console.log("UNMOUNTED");    
    this.clearBLEList();   
    clearInterval(); 
  }

  // shouldComponentUpdate(nextProps, nextState){
  //   console.log("Current State Count=", this.state.count
  //               , " Next State Count=" , nextState.count
  //               , " Current TimerTime=" , this.state.timerTime
  //               , " Next TimerTime=", nextState.timerTime
  //               , " Current State hasRun=", this.state.hasRun
  //               , "Next State hasRun=", nextState.hasRun );

  //   if(this.state.timerTime === 50 && nextState.timerTime === 150){
  //     console.log("in false Current State Count=", this.state.count
  //     , " Next State Count=" , nextState.count
  //     , " Current TimerTime=" , this.state.timerTime
  //     , " Next TimerTime=", nextState.timerTime 
  //     , " Current State hasRun=", this.state.hasRun
  //       , "Next State hasRun=", nextState.hasRun );
  //     return true;
  //   }
  //   return true
  // }
  
  handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
      });
    };

  tempCode = () => {
    
    this.props.history.push('/TempCodeRqst');
  }
  
  about = () => {
    
    this.props.history.push('/About');
  }
  scanCode = () => {
    
    this.props.history.push('/CodeScan');
  }

  openCloseCodes = () => {
    
    this.props.history.push('/OpenCloseCodes');
  }

  /* BLE FUN BEGIN */
  startHunting = async () => {
    //is ble on?
    this.setState({bleIsOn :  await window.AndroidInterface.bleCheck()});

    // console.log("in startHunting", this.state.bleIsOn);    

    if (this.state.bleIsOn){
        await window.AndroidInterface.startHunting(this.state.userId, this.state.orgId); 
        this.setState({vaultIdError: false});        
    }else{      
      this.setState({vaultIdError: true});         
    }
  }
 
  processBLE = async (deviceId) => {       
    let vaultData = null;
    
    if (deviceId !== "[]" && deviceId.length > 0){   

        vaultData = await vaultServices.fetchBLEDeviceInfo(deviceId);           
        // console.log("vaultData:",JSON.stringify(vaultData));
        if (vaultData != null){                  
          if (vaultData.status !== 400) {              
           //console.log("vd: ", JSON.stringify(this.state.vaultList)) 
            if(this.state.vaultList !== null){
                let newVaultList = union(this.state.vaultList, vaultData.data.results);                                
                let unique = uniqBy(newVaultList, 'deviceId');
                this.setState({vaultList: unique});  
                // this.vaultStatusRefresh(deviceId); 
                // if(!this.state.timerOn){
                //   this.startTimer(deviceId); 
                // } 
                               
            } 
            else{                
                this.setState({vaultList: vaultData.data.results});  
                // this.vaultStatusRefresh(deviceId);                              
                // if(!this.state.timerOn){
                //   this.startTimer(deviceId); 
                // } 
            }              
            if(this.state.vaultIdError.length > 0){
                  this.setState({vaultIdError:""});              
            }            
          }
          else {
              this.setState({vaultIdError: 'WARNING: Critical error! \nPlease contact your administrator'});        
              this.setState({loading: false});                    
          }                                   
        }       
    }
  }

  renderBLEDevices = () => {
    let data = this.state.vaultList;
    
    const {vaultList} = this.state;
   
    if(vaultList){
    const mapRows = data.map((item, index) => (       
        <React.Fragment key={index}>                                   
            <Typography component="div" variant="body1">
              <Box component="span" display="block" className={this.props.classes.box}>                              
              <Table className={this.props.classes.table}>               
                <TableBody>
                  <TableRow key={item.id} className={this.props.classes.tableRow}>
                    <TableCell align="left" colSpan={3}>
                    {item.assetTag}<br/>
                    {item.physicalLocation}
                    </TableCell>                    
                    <TableCell align="right">
                    {item.bleUseCode === 1 ?                                
                    (                                                                                                                                      
                      <CountDown deviceId={item.deviceId} firmware={item.firmware} vaultStatus={item.bleConnectionStatus}/>                                                               
                    )                                                  
                    : 
                    (
                     <BlockIcon color="secondary"/>
                     )}
                    </TableCell>
                  </TableRow>                  
                </TableBody>              
              </Table>
              </Box>
            </Typography>                                                             
        </React.Fragment>
    ));
    return mapRows;   
    } else{
      return null;
    }
  }
  
  //called from Android bridge
  listenForDevices = async (deviceIN) => {
    // console.log("listening", JSON.stringify(deviceIN));      
    await this.processBLE(deviceIN);   
  }
  
  clearBLEList = () => {
    window.AndroidInterface.clearBLEList();
  }

  //called from Android bridge
  sendAuditInfo = async (events) => {
    //  console.log("listening", JSON.stringify(deviceIN));      
    await vaultServices.sendAuditInfo(events); 
  }

//   /* Called from Android */
  runReload = (deviceIN) => {
    
    this.setState({
      vaultList: this.state.vaultList.filter(item => item.deviceId !== deviceIN.deviceId)
    });
}
  
  /* BLE FUN END */  
  
  /* FUN WITH TIMERS ...  */
  vaultStatusRefresh = (thisDevice) => {
    let vaultStatsChg = null;

    for (let i=0, l = this.state.vaultList.length; i < l; ++i){
      if (this.state.vaultList[i].deviceId === thisDevice) {                                
          vaultStatsChg = Object.assign(this.state.vaultList);
          vaultStatsChg[i].bleConnectionStatus = "ready";         

          this.setState({
            vaultList: vaultStatsChg,                    
          });
          break;
      }
    }  
  };

  

  /* END FUN */
 
/* ======================================================================================== */
  
  render() {   
    const { classes } = this.props; 
    const { disabled, vaultList, vaultIdError} = this.state;
    
    // console.log(JSON.stringify(this.state.foundVaults));
    
    if(vaultList && isMobile){
    
      return (       
        <div className="wrapper">        
          <Box className={classes.titleBLE}> 
          {vaultIdError &&           
           <React.Fragment>
            <div className={classes.boxBLEWarn}>
             <span style={{textAlign:"center"}}><strong>Attention</strong></span>
             <span style={{marginLeft:".5em"}}>You must have bluetooth enabled to discover vaults. Please
             enable bluetooth & click refresh</span><br/>
             <div style={{textAlign:"center"}}><Button type="button" className={classes.bleRefreshButton}   onClick={this.startHunting}>REFRESH</Button></div></div>           
           </React.Fragment>
           }
          <div>
              <p><i>Press any button on your vault<br/>to wake it up</i></p>                       
          </div>
          </Box>
          {/* <React.Fragment><div className={classes.bleListing}>{this.renderBLEDevices()}</div></React.Fragment> */}        
            <React.Fragment><div className={classes.bleListing}>{this.renderBLEDevices()}</div></React.Fragment>
            {/* <React.Fragment><ButtonAppBarFooter props={this.props}/></React.Fragment> */}
      </div>      
      );
    } else {
      return (       
        <div className="wrapper">
        {vaultIdError &&
           
          <React.Fragment>
          {/* <Paper className={classes.root}>  */}
          <div className={classes.boxBLEWarn}>
            <span style={{textAlign:"center"}}><strong>Attention</strong></span>
            <span style={{marginLeft:".5em"}}>You must have bluetooth enabled to discover vaults. Please
            enable bluetooth & click refresh</span><br/>
            <div style={{textAlign:"center"}}><Button type="button" className={classes.bleRefreshButton}   onClick={this.startHunting}>REFRESH</Button></div></div>
          {/* </Paper> */}
          </React.Fragment>
          
        }
        {isMobile &&
          <Box className={classes.titleBLE}>  
          <div>
              <p><i>Press any button on your vault<br/>to wake it up</i></p> 
              <React.Fragment><div className={classes.bleListing}></div></React.Fragment>      
          </div>
          {/* <React.Fragment><ButtonAppBarFooter props={this.props}/></React.Fragment> */}
          </Box>          
          
        }                      
            
        
      </div>      
    );
    }
  }
}
export default withStyles(styles)(Main);


// WEBPACK FOOTER //
// ./src/containers/main/main.js